import { Component, computed, EventEmitter, input, Input, Output } from '@angular/core';

@Component({
    selector: 'meta-content-preview',
    templateUrl: './content-preview.component.html',
    styleUrls: ['./content-preview.component.css']
})
export class ContentPreviewComponent {
    @Input() contentType: 'course' | 'guide' | 'paragraph' = 'paragraph';
    @Input() cover: string = '';
    @Input() title: string = '';
    @Input() duration: string = '';
    @Input() description: string = '';
    @Input() skills: string[] = [];
    @Input() banned: boolean = false;
    @Input() updated: boolean = false;
    @Input() students?: number | undefined;

    @Input() lowerHeight = false;
    @Input() showStarIcon = false;
    @Input() showCompletedIcon = false;
    @Input() showCertificateIcon = false;
    @Input() showProgress = false;
    @Input() showStudents = false;
    @Input() showSkills = false;
    @Input() showImage = false;
    @Input() showDescription = false;
    @Input() showContentTypeIcon = false;
    @Input() showLockIcon = false;

    @Input() progress: number | undefined;
    @Input() mandatoryProgress: number | undefined;
    $mandatoryPercent = input<number | undefined>(undefined, { alias: 'mandatoryPercent' });

    $mandatoryBarWidth = computed(() => {
        // ((mandatoryProgress / 100) * (mandatoryPercent / 100)) * 100
        if (this.mandatoryProgress && this.$mandatoryPercent()) {
            const x = ((this.mandatoryProgress / 100) * (this.$mandatoryPercent()! / 100))
            return parseFloat((x * 100).toFixed(2));
        }
        return 0;
    });

    @Output() clickCertificate = new EventEmitter<Event>();

    get contentTypeIcon() {
        switch (this.contentType) {
            case 'course':
                return 'school-course';
            case 'guide':
                return 'school-book';
            default:
                return 'paragraph';
        }
    }
}
